<template>
    <div class="dashboard-shortcut__list" v-if="permissions.kpi.caseOwnerEnabled || permissions.kpi.contractorEnabled">
        <template v-for="kpi in KPIList">
            <a v-if="!kpi.customFilter" :key="kpi.filter" :href="'#' + kpi.category" class="dashboard-shortcut-item" :class="getClass(kpi)" @click="updateFilters(kpi)">
                <div class="circle-big flexbox-center" :class="getClass(kpi)">
                    <div class="kpi-notification flexbox-center circle-small">
                        <icon class="small-svg fill-white" :name="getIcon(kpi)" />
                    </div>
                    <span>{{ kpi.count }}</span>
                </div>
                <div class="text">{{ getTitle(kpi) }}</div>
            </a>
        </template>
        <div v-for="kpi, index in customKPIList" :key="kpi.filter" class="dashboard-shortcut__item">
            <div class="count">{{ kpi.count }}</div>
            <div class="control" v-clickoutside="listClose">
                <button type="button" :id="`control-${kpi.filterId}-button`" :class="`control__button--${index}`"  class="control__button" aria-haspopup="true" :aria-expanded="itemIndex === index ? 'true' : 'false'" :aria-controls="`control-${kpi.filterId}-list`" @click="onButtonClick(index)" @keydown.down="onButtonDown(index)" @keydown.up="onButtonUp()">
                    <icon class="small-svg fill-white" name="chevron-right" style="transform: rotate(90deg);" />
                    <span class="visually-hidden">Vis redigeringsmuligheder</span>
                </button>
                <div class="control__list" :id="`control-${kpi.filterId}-list`" :class="{ 'control__list--hidden': itemIndex !== index }" :aria-labelledby="`control-${kpi.filterId}-button`" @keydown.down="onListDown()" @keydown.up="onListUp()" @keydown.esc="onListEscape()">
                    <ul role="menu">
                        <!-- <li role="none">
                            <button type="button" tabindex="-1" role="menuitem">Rediger</button>
                        </li> -->
                        <li role="none">
                            <button type="button" tabindex="-1" role="menuitem" @click="RemoveFilterFromKpi(kpi.filterId)">Slet</button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="text"><em>{{ kpi.filter }}</em></div>
            <button class="button" @click="updateFilters(kpi)"><span class="visually-hidden">Aktiver "{{ kpi.filter }}" filter</span></button>
        </div>

        <div v-if="customKPIList.length < itemLimit" class="dashboard-shortcut__item dashboard-shortcut__item--placeholder">
            <div class="count">+</div>
            <div class="text"><em>Tilføj filter</em></div>
            <button class="button" @click="openModal('dashboard-modal-filter-list', { isKpi: true })"><span class="visually-hidden">Tilføj filter</span></button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from '@/store/api.js'

import clickoutside from '@/mixins/shared/clickoutside.js'

export default {
    directives: {
        clickoutside
    },
    data () {
        return {
            itemLimit: 2,
            listShow: false,
            itemIndex: -1,
            filteringList: []
        }
    },
    computed: {
        ...mapGetters({
            KPIList: 'getKPI',
            permissions: 'permissions',

            getFilters: 'getFilters'
        }),

        customKPIList () {
            return this.KPIList.filter(kpi => kpi.customFilter)
        },

        interactiveElements () {
            return this.$el.querySelectorAll('.control__list [role="menuitem"]')
        }
    },
    mounted () {
        if (this.permissions.requisitions.enabled) {
            this.itemLimit = 4
        }
        document.addEventListener('click', this.clickOutside)
        axios.get('/Query/GetFilters')
            .then((response) => {
                this.filteringList = response.data.map((filtering) => {
                    return {
                        id: filtering.filterId,
                        type: filtering.filterType,
                        name: filtering.name,
                        parameterList: JSON.parse(filtering.parametersJson)
                    }
                })
            })
            .catch((error) => {
                console.error('error', error)
            })
    },
    destroyed () {
        document.removeEventListener('click', this.clickOutside)
    },
    methods: {
        ...mapActions({
            setKPI: 'setKPI',

            setSelectedTab: 'setSelectedTab',

            setCustomFilter: 'setCustomFilter',
            setFilters: 'setFilters',
            resetFilters: 'resetFilters'
        }),

        openModal (type, data) {
            this.$emit('openModal', type, data)
        },
        closeModal () {
            this.$emit('closeModal')
        },
        RemoveFilterFromKpi (id) {
            axios.post('/Query/RemoveFilterFromKpi', { filterId: id })
                .then((_) => {
                    this.setKPI()
                    this.listClose()
                    this.closeModal()
                })
                .catch((error) => {
                    console.error('error', error)
                })
        },
        getClass (kpi) {
            if (this.getFilters.kpi === 'tasksReadyForApproval' && kpi.filter === 'approveReady') {
                return 'js-active'
            }
            if (this.getFilters.kpi === 'requisitionsOverdue' && kpi.filter === 'overdue') {
                return 'js-active'
            }
            if (this.getFilters.kpi === 'requisitionsOpen' && kpi.filter === 'notClosed') {
                return 'js-active'
            }
        },
        getIcon (kpi) {
            if (kpi.filter === 'approveReady') {
                return 'task'
            }
            if (kpi.filter === 'overdue' || kpi.filter === 'notClosed') {
                return 'task-check'
            }
        },
        getTitle (kpi) {
            let title = ''

            if (kpi) {
                if (this.permissions.kpi.caseOwnerEnabled) {
                    if (kpi.filter === 'approveReady') {
                        title = 'Opgave' + (kpi.count < 1 || kpi.count > 1 ? 'r' : '') + ' færdigmeldt' + (kpi.count > 1 ? 'e' : '')
                    }
                }
                if (this.permissions.kpi.caseOwnerEnabled || this.permissions.kpi.contractorEnabled) {
                    if (kpi.filter === 'overdue') {
                        title = 'Entreprenøropgave' + (kpi.count < 1 || kpi.count > 1 ? 'r' : '') + ' overskredet'
                    } else if (kpi.filter === 'notClosed') {
                        title = 'Mine entreprenøropgaver'
                    }
                }
            }

            return title
        },
        updateFilters (kpi) {
            this.resetFilters('root')
            if (kpi.filter === 'approveReady') {
                this.setFilters({
                    filter: 'kpi',
                    value: 'tasksReadyForApproval'
                })
            } else if (kpi.filter === 'overdue') {
                this.setFilters({
                    filter: 'kpi',
                    value: 'requisitionsOverdue'
                })
            } else if (kpi.filter === 'notClosed') {
                this.setFilters({
                    filter: 'kpi',
                    value: 'requisitionsOpen'
                })
            } else {
                this.setFilters({
                    filter: 'kpi',
                    value: kpi.filter,
                    custom: true
                })
                const filtering = this.filteringList.find(f => f.id === kpi.filterId)
                if (filtering) {
                    this.resetFilters('user')
                    this.setCustomFilter(filtering)
                }
            }
            if (this.getSelectedTab !== kpi.category) {
                this.setSelectedTab(kpi.category)
            }
        },

        listOpen (index) {
            setTimeout(() => {
                this.listShow = true
                this.itemIndex = index
                this.setActive()
            }, 10)
        },
        listClose () {
            const closeIndex = this.itemIndex === 0 ? 1 : 0
            if (closeIndex !== -1) {
                this.itemIndex = -1
                this.listShow = false
            }
        },

        setActive () {
            if (this.interactiveElements.length > 0 && this.interactiveElements[this.itemIndex]) {
                this.$nextTick(() => {
                    this.$el.querySelector(`.control__button--${this.itemIndex}`).focus()
                })
            }
        },

        onButtonClick (index) {
            if (!this.listShow) {
                this.listOpen(index)
            } else {
                this.listClose()
            }
        },
        onButtonDown (index) {
            event.preventDefault()
            this.listOpen(index)
        },
        onButtonUp () {
            event.preventDefault()
            this.listClose()
        },
        onListDown () {
            event.preventDefault()
            this.itemIndex++
            if (this.itemIndex > this.interactiveElements.length - 1) {
                this.itemIndex = 0
            }
            this.setActive()
        },
        onListUp () {
            event.preventDefault()
            this.itemIndex--
            if (this.itemIndex < 0) {
                this.itemIndex = this.interactiveElements.length - 1
            }
            this.setActive()
        },
        onListEscape () {
            this.listClose()
        }
    },
    created () {
        if (this.permissions.kpi.caseOwnerEnabled || this.permissions.kpi.contractorEnabled) {
            this.setKPI()
        }
    }
}
</script>

<style lang="scss">
@import '../../../scss/components/kpi';
</style>



// WEBPACK FOOTER //
// src/components/shared/kpi/kpi.vue